var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"model-preview"},[_c('canvas',{ref:"canvas",attrs:{"role":"img","aria-label":_vm.component.description[0].name}}),(_vm.isKiosk)?_c('model-preview-controls',{staticClass:"cz2__360-viewer__controls-kiosk"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }